"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropdownHideDisabledOptionStyles = exports.dropdownDefaultStyles = exports.Theme = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("../../constants");
var _consts = require("./consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var dropdownDefaultStyles = exports.dropdownDefaultStyles = {
  control: function control(base, state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      boxShadow: 'none',
      borderRadius: state.menuIsOpen ? "".concat(_consts.borderRadius, "px ").concat(_consts.borderRadius, "px 0 0") : _consts.borderRadius,
      borderColor: _constants.colors.lightGrey,
      fontWeight: _constants.fontWeight.normal,
      ':hover': {
        borderColor: _constants.colors.lightGrey
      }
    });
  },
  option: function option(base, _state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      color: '#000',
      height: _consts.baseHeight
    });
  },
  menu: function menu(base, _state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      boxShadow: 'none',
      borderRadius: "0 0 ".concat(_consts.borderRadius, "px ").concat(_consts.borderRadius, "px"),
      border: "1px solid ".concat(_constants.colors.lightGrey),
      borderTop: 0,
      marginBottom: '24px'
    });
  },
  menuList: function menuList(base, _state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      padding: 0
    });
  },
  group: function group(base, _state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      paddingTop: 0,
      paddingBottom: 5,
      ':first-of-type': {
        paddingTop: 10
      },
      ':last-of-type': {
        paddingBottom: 0
      }
    });
  },
  valueContainer: function valueContainer(base, _state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      padding: '0 10px'
    });
  },
  multiValue: function multiValue(base, _state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      backgroundColor: 'none',
      position: 'relative',
      ':first-of-type': {
        marginLeft: 0
      }
    });
  },
  multiValueRemove: function multiValueRemove(base, _state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      position: 'absolute',
      paddingTop: 2,
      right: 5,
      top: 0,
      bottom: 0,
      color: _constants.colors.mediumGrey,
      ':hover': {
        background: 'none',
        cursor: 'pointer'
      }
    });
  },
  indicatorsContainer: function indicatorsContainer(base, _state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      padding: '0px 8px'
    });
  },
  clearIndicator: function clearIndicator(base, _state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      padding: '0'
    });
  },
  indicatorSeparator: function indicatorSeparator(_base, _state) {
    return {
      display: 'none'
    };
  },
  groupHeading: function groupHeading(base, _state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      textTransform: 'none',
      fontSize: 14
    });
  },
  menuPortal: function menuPortal(base, _state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      zIndex: 1300
    });
  }
};
var dropdownHideDisabledOptionStyles = exports.dropdownHideDisabledOptionStyles = _objectSpread(_objectSpread({}, dropdownDefaultStyles), {}, {
  option: function option(base, state) {
    return Object.assign(_objectSpread(_objectSpread({}, base), {}, {
      display: state.isDisabled ? 'none' : 'inherit'
    }), dropdownDefaultStyles.option());
  }
});
var Theme = exports.Theme = function Theme(baseTheme) {
  return {
    borderRadius: _consts.borderRadius,
    colors: _objectSpread(_objectSpread({}, baseTheme.colors), {}, {
      neutral20: _constants.colors.lightGrey,
      primary25: _constants.colors.babyBlue,
      primary50: _constants.colors.babyBlue,
      primary: _constants.colors.lighterGrey
    }),
    spacing: _objectSpread(_objectSpread({}, baseTheme.spacing), {}, {
      controlHeight: _consts.baseHeight,
      menuGutter: 0
    })
  };
};